import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLabelPipe',
  standalone: false
})
export class FormatLabelPipe implements PipeTransform {

  transform(value: string, args: Array<FormatDetailModel>): any {
    const item = args.find(x => x.name === value);
    return item ? item.text : '';
  }
}
